export default __webpack_public_path__ + "static/media/020-protected.6dc5127e.png";